<template>
  <div v-loading="tableLoading">
    <sw-table
      ref="completedTable"
      :page-sizes="[10,15,20]"
      :total-count="tableCount"
      :page-size="pageSize"
      :show-selection="false"
      :table-name="'sw-completed-table'"
      :table-title="tableTitle"
      :table-data="tableData"
      :table-operation="tableOperation"
      :has-add-button="false"
      style="background: #fff"
      @operation-handle="handleOperation"
      @size-change="changeSize"
      @change-page="changePage"
      @next-page="changePage"
      @prev-page="changePage"
    />
    <sw-dialog
      :title="'流程图'"
      :visible.sync="dialogIframeVisible"
      :destroy-on-close="true"
      top="50px"
      width="80vw"
    >
      <iframe
        :src="iframeSrc"
        style="border: none; width:  100%; height: calc(100vh - 145px)"
      />
    </sw-dialog>
  </div>
</template>
<script>
import service, { designFormUrl } from '@/utils/service.js'
import { parseTime } from '@/utils/index.js'
import '../css/worklist/applyfor.scss'
export default {
  data () {
    return {
      tableLoading: false,
      expandColumns: [],
      iframeSrc: '',
      dialogIframeVisible: false,
      currentPage: 1,
      pageSize: 10,
      tableCount: 0,
      tableData: [
      ],
      tableTitle: [
        {
          prop: 'actFormName',
          label: '服务名称',
          width: '120',
          sortable: true
        },
        { prop: 'createTime', label: '创建时间', width: '120', sortable: true }
      ],
      tableOperation: [
        { name: '删除', icon: 'su-icon-delete', operation: 'delete' },
        { name: '查看', icon: 'su-icon-details', operation: 'detail' }
      ]
    }
  },
  computed: {
    pageVisible () {
      return this.$store.state.appflow.pageVisible
    }
  },
  watch: {
    pageVisible (val) {
      if (val) {
        this.getData()
      }
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    handleWarningRow (approval) {
      if (approval.status === 'reject') {
        return true
      } else {
        return false
      }
    },
    getData () {
      this.tableLoading = true
      this.expandColumns = []
      service.get('/v1/draft/list', {
        params: {
          page: this.currentPage,
          limit: this.pageSize
        }
      }).then(res => {
        this.tableLoading = false
        this.tableData = res.data.map((item, index) => {
          item.createTime = parseTime(item.createTime)
          item.applyTime = parseTime(item.applyTime)
          return item
        })
        this.tableCount = res.count
      }).catch(error => {
        this.$swMessage.error(error)
      })
    },
    handleOperation (id, operation) {
      if (operation === 'delete') {
        this.deleteRow(id)
      } else if (operation === 'detail') {
        this.detailForm(id)
      }
    },
    deleteRow (id) {
      var param = {
        id: id
        // this.$route.params.fid
      }
      this.$swConfirm('确认删除？删除后不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          return service.get('/v1/draft/delete', { params: param })
        })
        .then((res) => {
          this.$swMessage.success(res.msg)
          this.getData()
        })
        .catch((res) => {
          this.$swMessage.error(res.msg)
        })
    },
    detailForm (id) {
      const data = this.tableData
      const len = data.length
      let row = null
      for (let i = 0; i < len; i++) {
        if (data[i].id === id) {
          row = data[i]
          break
        }
      }
      window.open(
        `${designFormUrl}/write?draftId=${id}&deployid=${row.actDefId}&fid=${row.actFormId}&from=adminplatform&dataType=draft&token=${localStorage.getItem('Admin-Token')}`,
        '_blank'
      )
    },
    changeSize (size) {
      this.pageSize = size
      this.currentPage = 1
      this.getData()
    },
    changePage (page) {
      this.currentPage = page
      this.getData()
    },
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
    }
  }
}
</script>
